import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Totaluser from './Apexchart/Totalusers';
import axios from 'axios';
import { SERVER_URL } from '../../../Config';


export default function Overview() {
  const Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: (i) => (
      <div
        style={{
          width: "5px",
          height: "5px",
          backgroundColor: "white",
          borderRadius: "50%",
          cursor: "pointer",
          marginTop: "10px"
        }}
      ></div>
    ),
    dotsClass: "slick-dots custom-dots",
  };

  const [transactions, setTransactions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/totalTransaction`);
        if (res.data.status) {
          setTransactions(res.data.transactions);
        } else {
          console.error("Error fetching transactions:", res.data.message);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchTransactions();
    fetchUserData();
  }, []);

  const filteredTransactions = transactions.filter(
    (transaction) =>
      transaction.from_email?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const ViewHash = (hash) => {
    window.open(`https://snowtrace.io/tx/${hash}`, "_blank");
  };

  const [userData, setUserData] = useState([]);
  const [labels, setLabels] = useState([]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/usersTenMonthCount`);
      const dataPoints = response.data.map(item => item.count);
      const labelPoints = response.data.map(item => item.month);
      setUserData(dataPoints);
      setLabels(labelPoints);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  return (
    <div className='bg-[#111111] my-5'>
      <div className='flex flex-col gap-2 lg:gap-0 lg:flex-row justify-between px-5'>
        <div className='lg:w-[33%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Balance</p>
          </div>
          <div className='bg-[#1E1E1E] px-4 py-7 rounded-md'>
            {/* <Slider {...Settings}> */}
            <div className='SLIDE-1 px-2 bg-[#1E1E1E]'>
              <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                <p className='font-inter text-white font-bold text-lg'>$0</p>
                <p className='text-[#A7A8AB] font-inter'>All Accounts</p>
              </div>
              <div className='bg-[#856E4F] px-4 py-2 mt-3 rounded-md'>
                <div className='flex justify-between '>
                  <div>
                    <p className='text-white font-inter'>Wallet Address</p>
                    <p className='text-white font-inter truncate'>0xb278E26........3639aD1</p>
                  </div>
                  <div className='flex justify-center items-center gap-2'>
                    <p className='font-inter font-bold text-white text-xl'>$0</p>
                    <img src='/assets/other/UpArrow.svg'></img>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className='SLIDE-2 px-2 bg-[#1E1E1E]'>
                <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                  <p className='font-inter text-white font-bold text-lg'>$240,399</p>
                  <p className='text-[#A7A8AB] font-inter'>All Accounts</p>
                </div>
                <div className='bg-[#856E4F] px-4 py-2 mt-3 rounded-md'>
                  <div className='flex justify-between '>
                    <div>
                      <p className='text-white font-inter'>Account type</p>
                      <p className='text-white font-inter'>**** **** **** 2598</p>
                    </div>
                    <div className='flex justify-center items-center gap-2'>
                      <p className='font-inter font-bold text-white text-xl'>$25000</p>
                      <img src='/assets/other/UpArrow.svg'></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='SLIDE-3 px-2 bg-[#1E1E1E]'>
                <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                  <p className='font-inter text-white font-bold text-lg'>$240,399</p>
                  <p className='text-[#A7A8AB] font-inter'>All Accounts</p>
                </div>
                <div className='bg-[#856E4F] px-4 py-2 mt-3 rounded-md'>
                  <div className='flex justify-between '>
                    <div>
                      <p className='text-white font-inter'>Account type</p>
                      <p className='text-white font-inter'>**** **** **** 2598</p>
                    </div>
                    <div className='flex justify-center items-center gap-2'>
                      <p className='font-inter font-bold text-white text-xl'>$25000</p>
                      <img src='/assets/other/UpArrow.svg'></img>
                    </div>
                  </div>
                </div>
              </div> */}
            {/* </Slider> */}
          </div>
        </div>
        <div className='lg:w-[33%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Deposit</p>
          </div>
          <div className='bg-[#1E1E1E] px-4 py-7 rounded-md'>
            <div className='SLIDE-1 px-2 bg-[#1E1E1E]'>
              <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                <p className='font-inter text-white font-bold text-lg'>$0</p>
                <p className='text-[#A7A8AB] font-inter'>Target</p>
              </div>
              <div className='bg-[#856E4F] px-4 py-2 mt-3 rounded-md'>
                <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                  <p className='font-inter text-white font-bold text-lg'>$0</p>
                  <p className='text-[#A7A8AB] font-inter'>Acheived</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:w-[33%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Withdraw</p>
          </div>
          <div className='bg-[#1E1E1E] px-4 py-7 rounded-md'>
            <div className='SLIDE-1 px-2 bg-[#1E1E1E]'>
              <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                <p className='font-inter text-white font-bold text-lg'>$0</p>
                <p className='text-[#A7A8AB] font-inter'>Target</p>
              </div>
              <div className='bg-[#856E4F] px-4 py-2 mt-3 rounded-md'>
                <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
                  <p className='font-inter text-white font-bold text-lg'>$0</p>
                  <p className='text-[#A7A8AB] font-inter'>Acheived</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='lg:w-[33%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Deposit</p>
          </div>
          <div className='bg-[#1e1e1e] px-4 py-2 rounded-md'>
            <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
              <p className='font-inter text-white font-bold text-lg flex gap-2 '>$240,399&nbsp;<img className='w-2/12' src='/assets/other/Frame 40640.svg'></img></p>
              <p className='text-[#A7A8AB] font-inter'>May, 2023</p>
            </div>
            <div className='flex flex-col lg:flex-row justify-between mt-3'>
              <div className='lg:w-[50%]'>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm'><img src='/assets/other/Award.svg'></img>&nbsp;Target Achieved</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$12,500</p>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm'><img src='/assets/other/octicon_goal-16.svg'></img>&nbsp;This month Target</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$20,000</p>
              </div>
              <div className='lg:w-[50%]'>
                <p className='text-center text-[#A7A8AB] text-xs 2xl:text-sm'>Target vs Achievement</p>
                <div className='flex justify-center'> <img className='w-6/12' src='/assets/other/file (39) 1.svg'></img></div>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:w-[33%]'>
          <div>
            <p className='font-inter text-[#878787]'>Total Withdraw</p>
          </div>
          <div className='bg-[#1e1e1e] px-4 py-2 rounded-md'>
            <div className='py-3 border-b-2 border-[#5f6060] flex justify-between'>
              <p className='font-inter text-white font-bold text-lg flex gap-2 '>$18,000&nbsp;<img className='w-2/12' src='/assets/other/Frame 40640.svg'></img></p>
              <p className='text-[#A7A8AB] font-inter'>May, 2023</p>
            </div>
            <div className='flex flex-col lg:flex-row justify-between mt-3'>
              <div className='lg:w-[50%]'>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm'><img src='/assets/other/Award.svg'></img>&nbsp;Target Achieved</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$12,500</p>
                <p className='text-[#878787] font-inter flex items-center text-xs 2xl:text-sm'><img src='/assets/other/octicon_goal-16.svg'></img>&nbsp;This month Target</p>
                <p className='text-[#A7A8AB] font-bold text-lg px-5'>$20,000</p>
              </div>
              <div className='lg:w-[50%]'>
                <p className='text-center text-[#A7A8AB] text-xs 2xl:text-sm'>Target vs Achievement</p>
                <div className='flex justify-center'> <img className='w-6/12' src='/assets/other/file (40) 1.svg'></img></div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className='flex flex-col lg:flex-row gap-5 justify-between px-5 mt-4'>
        <div className='lg:w-[35%]'>
          <div className='flex justify-between'>
            <p className='font-inter text-[#878787] text-xl'>Recent Transaction</p>
            {/* <p className='w-[30%] font-inter flex justify-end items-center gap-1 text-[#878787] text-xs'>View All&nbsp;<img className='w-2' src='/assets/other/Vector.svg'></img></p> */}
          </div>
          <div>
            <input className='mt-2 w-full rounded-full py-2 outline-none border border-[#3c3c3c] px-2 bg-[#111111] text-white placeholder:text-sm' placeholder='Enter a Email Id' value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}></input>
          </div>

          <div>
            {filteredTransactions?.length > 0 ? (

              filteredTransactions?.slice(0, 4)?.map((transaction, index) => (
                <div key={index} className='bg-[#1b1b1b] rounded-lg p-2 flex justify-between items-center mt-4'>
                  <div className='flex items-center gap-3'>
                    <img src='/assets/Profile/Sendprofile1.svg' className='w-12 2xl:w-14'></img>
                    <div>
                      <p className='font-Montserrat text-white '>{transaction.from_email}</p>
                      <p className='text-xs 2xl:text-sm font-Montserrat text-white '>{transaction.created_at}</p>
                    </div>
                  </div>
                  <div>
                    <p className=' font-Montserrat flex justify-center items-center gap-1 text-[#878787] text-xs'>-{transaction.amount}&nbsp;<img className='w-2 cursor-pointer' src='/assets/other/Vector.svg' onClick={() => ViewHash(transaction.trn_hash)}></img></p>
                  </div>
                </div>
              ))) : (
              <p className="text-center text-gray-500">No transactions found.</p>
            )}
          </div>

        </div>
        <div className='lg:w-[65%]'>
          <Totaluser data={userData} labels={labels} />
        </div>
      </div>
    </div>
  )
}
